import { TransactionCreate } from "./TransactionCreate";
import { TransactionEdit } from "./TransactionEdit";
import { TransactionList } from "./TransactionList";
import { TransactionShow } from "./TransactionShow";

export default {
  list: TransactionList,
  create: TransactionCreate,
  edit: TransactionEdit,
  show: TransactionShow,
};
